import React from 'react';

const shareText = `Kennst Du schon BIWAPP?
Mit dieser App bist Du bei Meldungen Deines Landkreises und im Katastrophenfall immer schnell informiert!`;
const shareURL = 'http://www.biwapp.de/app';

const shareOnFacebook = event => {
  event.preventDefault();
  FB.ui(
    {
      method: 'share',
      mobile_iframe: true,
      href: shareURL,
      quote: shareText,
    },
    () => {},
  );
};

const Recommend = () => (
  <div style={{ padding: '0 15px' }}>
    <p>
      Kennen Ihre Freunde, Familie und Kollegen schon BIWAPP?
      <br />
      <br />
      Wenn nicht, dann können Sie hier die App via den unten angegebenen Sozialen Medien
      weiterempfehlen:
    </p>
    <div className="SocialIcons SocialIcons--big">
      <a href="#0" onClick={shareOnFacebook} className="SocialIcon">
        <img
          className="SocialIcon-image"
          src="/images/social/facebook.png"
          alt="Auf Facebook teilen"
        />
      </a>
      <a
        href={`https://twitter.com/intent/tweet?text=${shareText}&url=${shareURL}`}
        target="_blank"
        className="SocialIcon"
      >
        <img
          className="SocialIcon-image"
          src="/images/social/twitter.png"
          alt="Auf Twitter teilen"
        />
      </a>
      <a
        href={`https://plus.google.com/share?url=${shareURL}`}
        target="_blank"
        className="SocialIcon"
      >
        <img
          className="SocialIcon-image"
          src="/images/social/googleplus.png"
          alt="Auf Google plus teilen"
        />
      </a>
    </div>
  </div>
);

export default Recommend;



// WEBPACK FOOTER //
// ./src/js/routes/Information/Recommend.js